import React from 'react';
import './Education.css';

function Education() {
  const educations = [
    {
      id: 1,
      institution: 'jagannath university jaipur Rajasthan',
      degree: 'bachelor of technology Science in Computer Science',
      duration: '2018 - 2022',
      description: 'Focused on advanced web development, algorithms, and artificial intelligence.',
      achievements: ['Graduated with honors', 'Published research paper on web optimization']
    },
    // {
    //   id: 2,
    //   institution: 'G.N.M College, Parsathua',
    //   degree: 'Bachelor of Science in Computer Science',
    //   duration: '2014 - 2018',
    //   description: 'Studied programming fundamentals, data structures, and web development.',
    //   achievements: ['Dean\'s List', 'Web Development Club President']
    // }


    {
  id: 1,
  institution: 'G.N.M College, Parsathua',
  degree: 'Intermediate in Science (I.Sc.)',
  duration: '2016 - 2018',
  description: 'Completed higher secondary education with a focus on science subjects.',
  subjects: [
    'Physics',
    'Chemistry',
    'Mathematics',
    'Hindi',
    'English'
  ],
  achievements: [
    'Secured top grades in Physics and Mathematics',
    'Participated in inter-school science exhibitions'
  ]
}

  ];

  const certifications = [
    {
      id: 1,
      name: 'React Developer Certification',
      issuer: 'Certification Authority 1',
      date: 'June 2021'
    },
    {
      id: 2,
      name: 'Advanced JavaScript',
      issuer: 'Certification Authority 2',
      date: 'March 2020'
    }
  ];

  return (
    <section className="education-section">
      <h1>Education & Certifications</h1>
      
      <div className="education-container">
        <h2>Academic Background</h2>
        {educations.map(edu => (
          <div key={edu.id} className="education-card">
            <h3>{edu.degree}</h3>
            <h4>{edu.institution}</h4>
            <p className="duration">{edu.duration}</p>
            <p className="description">{edu.description}</p>
            {edu.achievements.length > 0 && (
              <div className="achievements">
                <h5>Achievements:</h5>
                <ul>
                  {edu.achievements.map((achievement, index) => (
                    <li key={index}>{achievement}</li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        ))}
      </div>
      
      <div className="certifications-container">
        <h2>Certifications</h2>
        <div className="certification-cards">
          {certifications.map(cert => (
            <div key={cert.id} className="certification-card">
              <h3>{cert.name}</h3>
              <p>Issued by: {cert.issuer}</p>
              <p>Date: {cert.date}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Education;